import { useCallback } from 'react'

import { ScoredLoan } from '@mediaingenuity/totallymoney.types'

import useAppQueryState from '@hooks/useAppQueryState'
import { useBasin } from '@hooks/useBasin'

import { getAppConfig } from '@utils/getAppConfig'
import { getLoanApplicationUrl } from '@utils/getLoanApplicationUrl'
import { getMarketingTrackingData } from '@utils/getMarketingTrackingData'

interface UseGetLoanApplicationUrlOptions {
    clickId: string
    loan: ScoredLoan
    loanAmount: number
    loanTerm: number
    tablePosition: number
    thirdPartyReference: string
}

type UseGetLoanApplicationUrlReturn = (
    options: UseGetLoanApplicationUrlOptions
) => string

const appConfig = getAppConfig()

const useGetLoanApplicationUrl = (): UseGetLoanApplicationUrlReturn => {
    const { appQueryState } = useAppQueryState()
    const { ids } = useBasin()
    const trackingData = getMarketingTrackingData(appQueryState)

    const memoizedGetLoanApplicationUrl = useCallback(
        ({
            clickId,
            loan,
            loanAmount,
            loanTerm,
            thirdPartyReference,
            tablePosition,
        }: UseGetLoanApplicationUrlOptions) => {
            return getLoanApplicationUrl({
                clickId,
                loanId: loan.loanId,
                propositionId: loan.propositionId,
                loanAmount,
                loanTerm,
                whitelabelName: appConfig.NAME_WHITELABEL!,
                score: loan.score,
                clickQuery: loan.clickQuery,
                customerId: appQueryState.customerId!,
                thirdPartyReference: loan.ignoreThirdPartyReference
                    ? ''
                    : thirdPartyReference,
                rowNumber: tablePosition,

                customerOrigin: appQueryState.customerOrigin!,
                customerType: appQueryState.customerType!,

                visitGuid: ids!.sessionId,
                dailyId: ids!.dailyId,
                permanentId: ids!.permanentId,

                cam: trackingData.cam,
                gclid: trackingData.gclid,
                k: trackingData.k,
                m: trackingData.m,
            })
        },
        [
            appQueryState.customerId,
            appQueryState.customerOrigin,
            appQueryState.customerType,
            ids,
            trackingData.cam,
            trackingData.gclid,
            trackingData.k,
            trackingData.m,
        ]
    )

    return memoizedGetLoanApplicationUrl
}

export default useGetLoanApplicationUrl
